<style lang="less">
@import "../../../styles/public/public.less";
@import "../less/showmodel.less";

</style>
<template>
<div class="showmodel">
  <div class="showmodel_1 display_wrap_as set_yj">
    <titles titles="详细信息"></titles>
      <div v-for="item in editInfo" :key="item.name" class="showmodel_1hz display_row_ac media_w_showmodel1hz">
        <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00">
          <span>{{item.name}}:</span>
        </div>
        <div class="showmodel_1hz_2 display_row_ac dispaly_flex11 ">
          <span>{{item.value}}</span>
        </div>
      </div> 
      <div style="margin-top: 10px;" class="showmodel_1hz display_row_ac media_w_showmodel2hz">
        <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00">
          <span>备注:</span>
        </div>
        <div class="showmodel_1hz_2 display_row_ac dispaly_flex11 ">
          <span>{{comments}}</span>
        </div>
      </div>      
  </div>
</div>
</template>

<script>
import titles from "../../pages/title.vue";
import bus from "../../../app/event";
export default {
  components: {
    titles
  },
  data() {
    return {
      comments:'',//备注
      unit: {},
      disabled: false,
      editInfo:[
        {
          name:'用户名称',
          value:'',
          type:'mc',
        },
        {
            name: '用户账号',
            value: '',
            type: 'account',
        },
        {
          name:'用户密码',
          value:'',
          type:'password',
        },        
        {
          name:'性别',
          value:'',
          type:'gender',
        },
        {
          name:'联系电话',
          value:'',
          type:'dh',
        },
        {
          name:'邮箱',
          value:'',
          type:'postcode',
        },
        {
          name:'所属单位',
          value:'',
          type:'dw',
        },
        {
          name:'是否管理员',
          value:'',
          type:'isadmin',
        },
        {
          name:'出生年月',
          value:'',
          type:'birthday',
        },
        {
          name:'是否专家库成员',
          value:'',
          type:'ismember',
        },
      ]
    };
  },
  methods: {
  },
  mounted() {
    bus.$on('showuser',(showData)=>{
      this.editInfo.map((item,index)=>{
        item.value=showData[item.type];
        item.type=='password'?item.value='******':null;
      })
      this.comments=showData.REMARK;
    })
  },
  beforeDestroy(){
    bus.$off('showuser');
  },
  directives: {}
};
</script>


// WEBPACK FOOTER //
// showmodel.vue?1c55d02e